module.exports = __webpack_public_path__ + "static/img/coin9.c61d7af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/coin9.png
// module id = XQSd
// module chunks = 0